import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["name", "value"];
import env from '../services/AppEnv';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CsrfFormField',
    setup(__props) {
        const csrf = env.security.csrf;
        return (_ctx, _cache) => {
            return (_unref(csrf))
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "hidden",
                    name: _unref(csrf).param,
                    value: _unref(csrf).token
                }, null, 8, _hoisted_1))
                : _createCommentVNode("", true);
        };
    }
});
